/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';
import { Popover } from '@shopify/polaris';

import { RenderColorPicker2 } from 'src/components/views/common/forms/render-color-picker-2';
import IconTransparent from 'src/assets/images/common/transparent.svg';
import { hexToRgbA, convertRGBAStringToObject } from 'src/helpers/color-helper';

type Props = {
  colorValue: string,
  fieldName: string,
  fieldLabel: string,
  disabled?: boolean,
  updateField: (fieldName: string, color: Object) => void
};

type State = {
  rgbColor: string,
  activeColorPicker: boolean
};
class RenderColorPickerPopover extends Component<Props, State> {
  state = {
    rgbColor: '',
    activeColorPicker: false
  };

  componentDidMount() {
    const { colorValue } = this.props;
    // Calculate hex color
    this.setState({ rgbColor: hexToRgbA(colorValue) });
  }

  componentWillReceiveProps(nextProps: Props) {
    const { colorValue } = nextProps;
    const { rgbColor } = this.state;

    // Calculate hex color when change color from parent
    if (colorValue !== rgbColor) {
      this.setState({ rgbColor: hexToRgbA(colorValue) });
    }
  }

  render() {
    const { activeColorPicker, rgbColor } = this.state;
    const { colorValue, fieldName, fieldLabel, disabled = false } = this.props;

    const pickerItemClass = classnames('colorPickerItem', {
      disabled: disabled
    });
    const rgbObject = convertRGBAStringToObject(rgbColor);
    const activator =
      rgbObject.a !== 0 ? (
        <div
          className="colorPickerItem__box-color"
          style={{ backgroundColor: rgbColor }}
          onClick={!disabled ? this.handleOpenColorPicker : null}></div>
      ) : (
        <div
          className="colorPickerItem__box-color"
          style={{ border: 'none' }}
          onClick={!disabled ? this.handleOpenColorPicker : null}>
          <img src={IconTransparent} alt="transparent" />
        </div>
      );

    return (
      <div
        className={pickerItemClass}
        style={{ alignItems: _.isEmpty(colorValue) ? 'flex-start' : 'center' }}>
        <Popover
          active={activeColorPicker}
          activator={activator}
          onClose={this.handleOpenColorPicker}
          preferredAlignment="left">
          <Field
            name={fieldName}
            component={RenderColorPicker2}
            color={rgbObject}
            onChange={this.handleChangeColor}
            normalize={color => (color.rgb ? this.parseRGBToString(color.rgb) : '')}
          />
        </Popover>
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <span className="Polaris-Label__Text">{fieldLabel}</span>
          </div>
          <div className="Polaris-Color">
            <span className="Polaris-Color__Text">{rgbColor}</span>
          </div>
        </div>
      </div>
    );
  }

  parseRGBToString = (rgbColor: Object) => {
    return !_.isEmpty(rgbColor)
      ? `rgba(${rgbColor?.r}, ${rgbColor?.g}, ${rgbColor?.b}, ${rgbColor?.a})`
      : '';
  };

  handleOpenColorPicker = () => {
    this.setState(({ activeColorPicker }) => ({
      activeColorPicker: !activeColorPicker
    }));
  };

  handleChangeColor = (color: Object) => {
    const { rgb: rgbColor } = color;
    this.setState({ rgbColor: this.parseRGBToString(rgbColor) });
  };
}

export default RenderColorPickerPopover;
